import { useCallback } from 'react'
import ApiService from 'services/ApiService'
import { getMessage } from 'utility/MapperResponse'
import { showAlert } from 'utility/SweetAlert'

const InteractorWarehouseStockMoveView = () => {
  const stockMoveView = useCallback((body, callback, loading) => {
    const payload = { ...body }
    ApiService.jsonRequest('/warehouse/stock-move/view', payload, (response) => {
      if (response.code === 7200) {
        callback(response.data)
      } else {
        showAlert({
          icon: 'error',
          message: getMessage(response?.msg),
          timer: 2000,
          redirect: '/warehouse/stock-move/manage',
        })
      }
      loading(false)
    })
  }, [])

  return { stockMoveView }
}

export default InteractorWarehouseStockMoveView
